import { useTooltip } from "@website/ui/tooltip/tooltip.hook";
import styles from "@website/ui/tooltip/tooltip.module.scss";
import { TooltipPropertiesType } from "@website/ui/tooltip/tooltip.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Tooltip: FC<TooltipPropertiesType> = (properties) => {
  const {
    title,
    children,
    placement,
    color,
    variant,
    className,
    titleClassName
  } = properties;
  const { titleProperties, tooltipProperties } = useTooltip(properties);

  return (
    <div className={className}>
      <div className={`${styles["tooltip"]} !w-full`} {...tooltipProperties}>
        {children}
        <span
          className={`${titleClassName} ${styles["title"]} ${
            styles[placement || "bottom"]
          } ${styles[color || "neutral"]} ${styles[variant || "wrap"]}`}
          {...titleProperties}
        >
          {title}
        </span>
      </div>
    </div>
  );
};

const TooltipMemoized = memo(Tooltip, deepCompare);
export { TooltipMemoized as Tooltip };
